import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import PropostaOutroCanal from 'src/app/shared/models/proposta-outro-canal.model';
import DateUtils from 'src/app/shared/utils/date-utils';

@Component({
  selector: 'app-propostas-outros-canais-modal',
  templateUrl: './propostas-outros-canais-modal.component.html',
  styleUrls: ['./propostas-outros-canais-modal.component.scss']
})
export class PropostasOutrosCanaisModalComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<PropostasOutrosCanaisModalComponent>,
    @Inject(MAT_DIALOG_DATA) public propostasOutrosCanais: PropostaOutroCanal[],
  ) { }

  ngOnInit(): void { }

  normalizeDate(proposta: PropostaOutroCanal) {
    return DateUtils.normalizedDate(proposta.dataEntrada);
  }

}
